// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2b98H","rootMobile":"styles_rootMobile__2k0X_"};